<template>
  <div class="relative video-wrapper">
    <video :id="uniqID" :src="src + '#t=0.1'" preload="metadata" class="w-full" @click="openFullscreen()" @ended="onVideoEnded()" playsinline/>
    <div class="video-controls opacity-0 transition ease-in-out duration-500 hover:opacity-100">
      <fai v-if="showPlayButton" class="absolute top-1/2 left-1/2 cursor-pointer" :icon="['far', 'fa-circle-play']" @click="playVideo" size="5x"/>
      <fai v-else class="absolute top-1/2 left-1/2 cursor-pointer" :icon="['far', 'fa-circle-pause']" @click="pauseVideo" size="5x"/>
    </div>
  </div>
</template>

<script>

export default {
  name: "VideoPlayer",
  props: {
    src: {
      type: String,
      required: true
    },
    uniqID: {
      type: String,
      default: 'video_player'
    },
    allowFullscreen : {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPlayButton: true
    }
  },
  methods: {
    playVideo() {
      this.showPlayButton = !this.showPlayButton
      const el = document.getElementById(this.uniqID)
      if (el.muted) el.muted = false
      if (el) el.play().catch(() => {
        el.muted = true
        el.play()
      })
    },
    pauseVideo() {
      this.showPlayButton = true
      const el = document.getElementById(this.uniqID)
      if (el) el.pause()
    },
    onVideoEnded() {
      const video = document.getElementById(this.uniqID)
      if (video) {
        video.currentTime = 0;
        this.showPlayButton = true
        if (!this.beenUserInteraction) this.$emit('onVideoEnded');
      }
    },
    openFullscreen() {
      if (!this.allowFullscreen) return;
      const el = document.getElementById(this.uniqID)
      if (el) el.requestFullscreen()
    }
  }
}
</script>

<style lang="scss" scoped>
.video-wrapper {
  video:hover + .video-controls {
    opacity: 1;
  }

  .video-controls {

    svg {
      width: 100px;
      height: 100px;
      transform: translate(-50%, -50%);

      path {
        fill: white;
      }
    }
  }
}
</style>